import type { ReactNode } from 'react';

interface StateMessageProps {
  readonly title: string;
  readonly description: string;
  readonly tone?: 'neutral' | 'error';
  readonly action?: ReactNode;
}

export function StateMessage({ title, description, tone = 'neutral', action }: StateMessageProps) {
  return (
    <div role={tone === 'error' ? 'alert' : undefined} className="flex flex-col items-start gap-2 py-6">
      <p className={`font-display text-lg ${tone === 'error' ? 'text-debit' : 'text-ink'}`}>{title}</p>
      <p className="max-w-prose text-sm text-muted">{description}</p>
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}
